import { CIcon } from '~/icons/types'

export const ciAddToList: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M11.82 16.25H3.9a1 1 0 0 0 0 2h7.918a1 1 0 0 0 0-2Zm-7.919-8.5h16.197a1 1 0 0 0 0-2H3.9a1 1 0 0 0 0 2Zm16.197 8.5h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 0 0 0-2Zm0-5.25H3.9a1 1 0 0 0 0 2h16.197a1 1 0 0 0 0-2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'add-to-list',
  type: 'regular'
}
